import type { TFunction } from 'i18next';

/**
 * zod messages are i18n keys, optionally with parameters: "validation.maxLength?max=255".
 * They are translated when rendered, so switching the language re-translates visible errors.
 */
export function msg(key: string, params?: Record<string, string | number>): string {
  if (!params) return key;
  return `${key}?${new URLSearchParams(Object.entries(params).map(([k, v]) => [k, String(v)])).toString()}`;
}

export function translateError(t: TFunction, message: string | undefined): string | undefined {
  if (!message) return undefined;
  const [key, query] = message.split('?', 2);
  if (!key) return message;
  if (!key.includes('.') || key.includes(' ')) return message; // already a translated server message
  const params: Record<string, string | number> = {};
  if (query) new URLSearchParams(query).forEach((v, k) => (params[k] = Number.isNaN(Number(v)) ? v : Number(v)));
  return t(key, params);
}
